module.exports = __webpack_public_path__ + "img/c++-high-performance.98645643.png";